import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import WerkorderModal from './WerkorderModal';
import './AfgerondeWerkorders.css';
import api from '../services/api';

const AfgerondeWerkorders = () => {
  const { gebruiker, logout } = useAuth();
  const navigate = useNavigate();
  const [werkorders, setWerkorders] = useState([]);
  const [showWerkorderModal, setShowWerkorderModal] = useState(false);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('maand');

  useEffect(() => {
    loadWerkorders();
    // Markeer als gezien
    localStorage.setItem("lastVisitAfgerond", new Date().toISOString());
  }, [filter]);

  const loadWerkorders = async () => {
    try {
      const response = await api.get(`/werkorders/afgerond?filter=${filter}`);
      setWerkorders(response.data.werkorders || []);
      setLoading(false);
    } catch (error) {
      console.error('Fout bij laden afgeronde werkorders:', error);
      setLoading(false);
    }
  };

  // MARKER-ADMIN-VERWERKT-FA
  const toggleAdminVerwerkt = async (id, verwerkt) => {
    try {
      await api.put(`/werkorders/${id}/administratief`, { verwerkt });
      loadWerkorders();
    } catch (e) {
      alert('Fout bij bijwerken');
    }
  };

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const getStatusBadge = () => 'badge-afgerond';
  const getPrioriteitIcon = (prioriteit) => {
    const icons = { 'laag': '🟢', 'normaal': '🟡', 'hoog': '🔴' };
    return icons[prioriteit] || '⚪';
  };

  return (
    <div className="afgeronde-werkorders">

      <div className="dashboard-container">
        <div className="dashboard-header">
          <h1>✅ Afgeronde Werkorders</h1>
          <div className="header-actions">
          </div>
        </div>

        <div style={{ padding: '15px 0', borderBottom: '1px solid #e5e7eb', marginBottom: '20px' }}>
          <select value={filter} onChange={(e) => setFilter(e.target.value)} style={{ padding: '8px 12px', borderRadius: '6px', border: '1px solid #d1d5db', fontSize: '14px' }}>
            <option value="maand">Deze maand</option>
            <option value="jaar">Dit jaar</option>
            <option value="alles">Alles</option>
          </select>
        </div>

        <div className="dashboard-stats">
          <div className="stat-card stat-afgerond">
            <div className="stat-number">{werkorders.length}</div>
            <div className="stat-label">Afgerond ({filter})</div>
          </div>
        </div>

        <div className="werkorders-section">
          <h2>Afgeronde Werkorders</h2>
          {loading ? (
            <div className="loading">Laden...</div>
          ) : werkorders.length === 0 ? (
            <div className="no-werkorders">
              <p>Geen afgeronde werkorders in deze periode</p>
            </div>
          ) : (
            <div className="werkorders-list">
              {werkorders.map(werkorder => (
                <div key={werkorder.id} className="werkorder-card" onClick={() => navigate(`/werkorder/${werkorder.id}`)}>
                  <div style={{padding:'8px 12px',background:werkorder.administratief_verwerkt?'#d1fae5':'#fef3c7',borderBottom:'1px solid '+(werkorder.administratief_verwerkt?'#10b981':'#fbbf24'),display:'flex',justifyContent:'space-between',alignItems:'center'}} onClick={(e)=>e.stopPropagation()}>
                    {werkorder.administratief_verwerkt ? (
                      <>
                        <span style={{color:'#047857',fontWeight:600,fontSize:13}}>✓ Administratief verwerkt{werkorder.administratief_verwerkt_op?' · '+new Date(werkorder.administratief_verwerkt_op).toLocaleDateString('nl-NL'):''}</span>
                        <button onClick={()=>toggleAdminVerwerkt(werkorder.id,false)} style={{background:'transparent',border:'1px solid #10b981',color:'#047857',borderRadius:6,padding:'3px 10px',cursor:'pointer',fontSize:12}}>Ongedaan maken</button>
                      </>
                    ) : (
                      <>
                        <span style={{color:'#92400e',fontSize:13}}>Nog niet administratief verwerkt</span>
                        <button onClick={()=>toggleAdminVerwerkt(werkorder.id,true)} style={{background:'#10b981',color:'white',border:'none',borderRadius:6,padding:'4px 12px',cursor:'pointer',fontSize:12,fontWeight:600}}>✓ Markeer als verwerkt</button>
                      </>
                    )}
                  </div>
                  <div className="werkorder-header">
                    <div className="werkorder-title-row">
                      <h3>{getPrioriteitIcon(werkorder.prioriteit)} {werkorder.titel}{werkorder.oa_afgemeld_door && <span title="Uitgevoerd door onderaannemer" style={{ marginLeft: 8, fontSize: 12, fontWeight: 700, padding: '3px 10px', borderRadius: 999, background: '#fef3c7', color: '#92400e', verticalAlign: 'middle', whiteSpace: 'nowrap' }}>🤝 {werkorder.oa_afgemeld_door}{werkorder.status !== 'afgerond' && werkorder.oa_gereed_op ? ' · gereed gemeld, te controleren' : ''}</span>}</h3>
                      <span className={`badge ${getStatusBadge()}`}>Afgerond</span>
                    </div>
                  </div>
                  <p className="werkorder-beschrijving">{werkorder.beschrijving}</p>
                  <div className="werkorder-meta">
                    <span>🏢 {werkorder.afdeling_naam || 'Geen afdeling'}</span>
                    {werkorder.toegewezen_aan_voornaam && (
                      <span>👤 {werkorder.toegewezen_aan_voornaam} {werkorder.toegewezen_aan_achternaam}</span>
                    )}
                    <span>✅ {new Date(werkorder.afgerond_op).toLocaleDateString('nl-NL')}</span>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      <WerkorderModal show={showWerkorderModal} onClose={() => setShowWerkorderModal(false)} onSuccess={() => setShowWerkorderModal(false)} />
    </div>
  );
};

export default AfgerondeWerkorders;
